import type { VersionInfo } from '@/utils'

export type VersionBadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline'

/** Badge variant for the running environment. */
export function resolveVersionBadgeVariant(versionInfo: VersionInfo): VersionBadgeVariant {
  if (versionInfo.isLocal) {
    return 'destructive'
  }

  if (versionInfo.isStaging) {
    return 'secondary'
  }

  if (versionInfo.isProduction) {
    return 'default'
  }

  if (versionInfo.isTest) {
    return 'outline'
  }

  return 'default'
}

/** Badge colour classes for the running environment. */
export function resolveVersionBadgeColorClassName(versionInfo: VersionInfo): string {
  if (versionInfo.isLocal) {
    return 'bg-[#ff6b35] hover:bg-[#ff6b35]/90 text-white border-transparent'
  }

  if (versionInfo.isStaging) {
    return 'bg-[#ffa500] hover:bg-[#ffa500]/90 text-white border-transparent'
  }

  if (versionInfo.isProduction) {
    return 'bg-[#28a745] hover:bg-[#28a745]/90 text-white border-transparent'
  }

  if (versionInfo.isTest) {
    return 'bg-[#6c757d] hover:bg-[#6c757d]/90 text-white border-transparent'
  }

  return 'bg-[#28a745] hover:bg-[#28a745]/90 text-white border-transparent'
}
